import { z } from 'zod'

import { ApplicationError, type UserInformation } from '../domain'

export abstract class ForManagingAccount {
	static Profile = z.object({
		firstName: z
			.string()
			.regex(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, {
				message:
					'The first name can only contain letters and one space between words.'
			})
			.max(30, {
				message: 'The first name must be at most 30 characters long.'
			})
			.optional(),
		lastName: z
			.string()
			.regex(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, {
				message:
					'The last name can only contain letters and one space between words.'
			})
			.max(30, {
				message: 'The last name must be at most 30 characters long.'
			})
			.optional(),
		handler: z
			.string()
			.regex(/^[a-z][a-z0-9-]*[a-z0-9]$/, {
				message:
					'The username must start with a letter and can only contain lowercase letters, numbers, and hyphens.'
			})
			.min(2, { message: 'The username must be at least 2 characters long.' })
			.max(25, { message: 'The username must be at most 25 characters long.' })
			.refine(val => !val.includes('--') && !val.match(/-\d{4}$/), {
				message:
					'The username cannot have consecutive hyphens or end with a hyphen before the four random numbers.'
			})
	})

	abstract getUserInfo(): Promise<{
		data?: UserInformation
		error?: ApplicationError
	}>

	abstract signIn(
		authToken: string,
		appCheck: string
	): Promise<{
		data?: UserInformation
		error?: ApplicationError
		status?: number
	}>

	abstract signUp(payload: {
		first_name?: string
		last_name?: string
		id_token: string
		handler: string
	}): Promise<{
		data?: UserInformation
		error?: ApplicationError
	}>

	abstract sendSignInEmail(
		email: string,
		continueUrl: string,
		appCheckToken: string
	): Promise<{
		error?: ApplicationError
	}>

	abstract signOut(): Promise<{
		error?: ApplicationError
	}>
}
